// extracted by mini-css-extract-plugin
export default {"runningListDiv":"Courses_runningListDiv__+7H5s","courseCard":"Courses_courseCard__7WvHg","dateDiv":"Courses_dateDiv__05XK9","editButton":"Courses_editButton__dYLeO"};